import PrelevementConfigImpressionController from './prelevement.config.impression.controller';

export default {
    bindings: {
        saisie: '='
    },
    template: require('./prelevement.config.impression.html'),
    controller: PrelevementConfigImpressionController
};
